module.exports = __webpack_public_path__ + "img/logo-fivenomics.68909bdc.svg";